import React, { useState, useEffect, useRef } from 'react';
import ICONS from '../config/icon';
import CourseCard from './CourseCard';
import { useInsertName } from "./utils/helpers";

import { PaperBG, PaperDarkBG, UnderlineSketch, PaperGradientBG } from '../kits';

import CustomCourseRequestPr from './CustomCourseRequestPr';
import ModalWrapper from './utils/ModalWrapper';
import { createPortal } from "react-dom";



function SectionC() {
  const [searchQuery, setSearchQuery] = useState('');
  const [isSearching, setIsSearching] = useState(false);
  const [courses, setCourses] = useState([]);
  const [filteredCourses, setFilteredCourses] = useState([]);
  const coursesSectionRef = useRef(null);
  const name = useInsertName();
    const [showModal, setShowModal] = useState(false);



      const handleCloseModal = () => {
  setShowModal(false);
  setSearchQuery("");
  setIsSearching(false);
  setFilteredCourses([]);
};

  useEffect(() => {
    if (isSearching && filteredCourses.length === 0) {
      setShowModal(true);
    }
  }, [isSearching, filteredCourses]);


  // Kurse vom Backend laden
  useEffect(() => {
    fetch("https://www.denisbitter.de/stage01/api/get_courses.php")
      .then((res) => res.json())
      .then((data) => {
        if (data.success && Array.isArray(data.data)) {
          setCourses(data.data);
        } else {
          console.error('Ungültige Kursdaten.');
        }
      })
      .catch((err) => console.error('Fehler beim Laden:', err));
  }, []);

  // Suche ausführen
  const performSearch = (query) => {
    const regex = new RegExp(
      query
        .toLowerCase()
        .trim()
        .replace(/\s+/g, '.*')
        .split(' ')
        .map(word => `(?=.*${word})`)
        .join(''),
      'i'
    );



    const results = courses.filter((course) => {
      const descriptionText = Array.isArray(course.description)
        ? course.description.join(' ')
        : course.description || '';

      return (
        regex.test(course.title) ||
        regex.test(descriptionText) ||
        regex.test(course.instructor) ||
        regex.test(course.category)
      );
    });

    setFilteredCourses(results);
    setIsSearching(true);
  };

  // Input-Änderung verarbeiten
  const handleSearchInputChange = (event) => {
    const value = event.target.value;
    setSearchQuery(value);

    if (value.trim() === '') {
      setIsSearching(false);
      setFilteredCourses([]);
    } else {
      performSearch(value);
    }
  };

  return (
    <>
    <PaperBG>
    <div>
      {/* Sucheingabe */}
      <PaperGradientBG>
      <section className="py-16 sm:py-20 md:py-24">
        <div className="container mx-auto text-center px-6 max-w-4xl">
          <h1 className="text-2xl sm:text-3xl md:text-4xl font-mono text-amber-100 mb-6 leading-relaxed">
            Was{" "}
            <span className="text-brand relative inline-block">
              interessiert
              <UnderlineSketch
                className="absolute -bottom-1 left-0 w-full h-2"
                color="zenBrand"
              />
            </span>
            <br />
            dich gerade,{" "}
            <span className="text-brand relative inline-block">
              {name}
              <UnderlineSketch
                className="absolute -bottom-1 left-0 w-full h-2"
                color="zenBrand"
              />
            </span>
          </h1>

   

          <div className="relative max-w-3xl mx-auto py-5">
            <input
              type="text"
              value={searchQuery}
              onChange={handleSearchInputChange}
              placeholder="3D , Web, React ..."
              className="w-full px-6 py-4 text-gray-900 text-xs font-mono sm:text-center  bg-gradient-to-br from-[#FAF6F1] to-[#F5EFE7]border border-gray-700 rounded-xl focus:outline-none focus:ring-1 focus:ring-white/20 placeholder-gray-500"
            />
            <span className="absolute right-6 top-4 text-gray-500 text-xs sm:text-xl"></span>
          </div>
        </div>
      </section>
</PaperGradientBG>




      {/* Suchergebnisse */}
      {isSearching && (
        <section ref={coursesSectionRef} className="py-16 bg-gray-50">
          <div className="container mx-auto px-6">
            {filteredCourses.length > 0 ? (
              <>
                <h3 className="text-xs font-mono mb-10 text-center">
                  Ich habe ein paar Kurse gefunden, die dich interessieren könnten, {name}.
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                  {filteredCourses.map((course) => (
                    <CourseCard
                      key={course.id}
                      course={course}
                      icon={ICONS[course.icon] || ICONS.default}
                    />
                  ))}
                </div>
              </>
            ) : (
              <div className="text-center font-mono">
{showModal &&
  typeof document !== "undefined" &&
  document.getElementById("modal-root") &&
  createPortal(
    <ModalWrapper onClose={handleCloseModal}>
      <CustomCourseRequestPr onClose={handleCloseModal} />
    </ModalWrapper>,
    document.getElementById("modal-root")
  )
}
              </div>
            )}
          </div>
                 
        </section>

      )}
    </div>
    </PaperBG>
    </>
  );
}

export default SectionC;
